import React from "react";
import { Popconfirm } from "antd";
import "./ChantPopConfirm.css";

const ChantPopConfirm = ({
  title,
  description,
  onConfirm,
  onCancel,
  okText = "Yes",
  cancelText = "No",
  okButtonProps,
  cancelButtonProps,
  okButton,
  cancelButton,
  placement = "topRight",
  overlayClassName = "chant-popconfirm",
  children,
  ...props
}) => {
  return (
    <Popconfirm
      title={title}
      description={description}
      onConfirm={onConfirm}
      onCancel={onCancel}
      okText={okText}
      cancelText={cancelText}
      okButtonProps={okButtonProps}
      cancelButtonProps={cancelButtonProps}
      okButton={okButton}
      cancelButton={cancelButton}
      placement={placement}
      overlayClassName={overlayClassName}
      {...props}
    >
      {children}
    </Popconfirm>
  );
};

export default ChantPopConfirm;
